// Vendors
import { CountriesIsoCodesConstants, CountriesIsoCodesEnum, CountriesLocaleConstants, CountriesLocaleEnum, StorageLocalEnum, } from '@openbank/ziniaweb-ui-core-models';
// Constants
import constants from './constants/locale.constants';
const extractRegionFromLocale = (locale) => locale?.split(constants.SPLIT_REGEX, 1)?.[0];
const getLocaleFromBrowser = () => CountriesLocaleConstants[extractRegionFromLocale(window.navigator.language).toUpperCase()];
const getAppLocale = () => localStorage.getItem(StorageLocalEnum.LOCALE) || getLocaleFromBrowser() || CountriesLocaleEnum.ENGLAND;
const getISOCountry = () => localStorage.getItem(StorageLocalEnum.COUNTRY) ||
    CountriesIsoCodesConstants[extractRegionFromLocale(window.navigator.language)] ||
    CountriesIsoCodesEnum.ENGLAND;
export { extractRegionFromLocale, getAppLocale, getLocaleFromBrowser, getISOCountry };
//# sourceMappingURL=locale.utils.js.map